<style lang="sass">

    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import ../../common/styles/ui/popup

    @import ./hero
    @import ./persona
    @import ./follow
    @import ./publication

    .node-homepage

        &__datanav-articles
            margin-top: 6rem
            +media("<=desktop")
                margin-top: 0

        &__bottom
            position: relative
            z-index: 1
            cursor: pointer
            bottom: -2rem
            left: calc(50% - 1rem)
            transform: translate(-50%, -50%)
            background-image: url(../../common/graphics/arrow-down.svg)
            width: 1.7rem
            height: 1.7rem
            transform-origin: top
            animation: bounceHomepage 1s $authentic-motion-out

            @keyframes bounceHomepage
                from
                    transform: translateY(40%)

                50%
                    transform: translateY(0%)

                to
                    transform: translateY(40%)

        &__shortcut
            position: absolute
            bottom: 0
            left: 50%
            transform: translateX(-50%)
            z-index: 1
            margin-bottom: 2rem
            padding-top: 4rem
            color: #fff
            z-index: 19

            +media("<tablet")
                display: none !important

            +media("<=desktop")
                margin-bottom: 1rem
                padding-top: 2.5rem

            &:after
                content: ""
                position: absolute
                top: 50%
                left: 50%
                width: 40px
                height: 40px
                transform: translate(-50%, -50%)
                border: 2px solid #fff
                border-radius: 50px
                transition-duration: 1s

            &:before
                content: ""
                position: absolute
                top: 50%
                left: 50%
                width: 16px
                height: 16px
                transform: translate(-50%, -70%) rotate(-45deg)
                border-left: 2px solid #fff
                border-bottom: 2px solid #fff
                transition-duration: 1s

            &:hover
                &:after
                  transform: translate(-50%)
                  transition-duration: 1s

                &:before
                  transform: translate(-50%, 10px) rotate(-45deg)
                  transition-duration: 1s

</style>

<script>
    // import URI from 'urijs'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import {Bus as VuedalsBus} from "vuedals"
    import YoutubePopin from "../paragraph-youtube/YoutubePopin.vue"
    import $ from 'jquery'

    export default {

        props: [ 'youtube' ],
        components: {
            swiper,
            swiperSlide
        },
        mounted () {

            setTimeout(() => {
                this.initPlayer();
                //this.$refs.slider.swiper.update();
                window.AOS.init({ disable: 'mobile', offset: 300 });
            }, 1000);

            setTimeout(() => {
                window.AOS.init({disable: 'mobile', offset: 30})
            }, 1000);

            $('.node-homepage__shortcut').on('click', function(e) {
              e.preventDefault();
              $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 1750, 'swing');
            });

        },

        data () {
            return {
                swiperOption: {
                    nextButton: '.node-homepage__articles__arrows .arrow--right',
                    prevButton: '.node-homepage__articles__arrows .arrow--left',
                    loop: false,
                    effect: 'fade',
                    autoplay: 5000,
                    breakpoints: {
                        // when window width is <= 320px
                        1000: {
                            effect: 'slide'
                        }
                    }
                },
                player: null,
                $iframe: null,
                articlesTagsOptions: [],
                articlesTag: "all"
            }
        },

        methods: {

            initPlayer: function() {
                let  tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";

                let firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                setTimeout(() => {
                    this.player = new YT.Player('player', {
                        height: '100%',
                        width: '100%',
                        videoId: this.videoYoutubeId,
                        playerVars: {
                            'autoplay': 1,
                            'controls': 0,
                            'rel' : 0,
                            'fs' : 0,
                            'loop': 1,
                            'modestbranding': 1,
                            'showinfo': 0,
                            'playlist': this.videoYoutubeId
                        },
                        events: {
                            'onReady': (event) => {
                                event.target.setVolume(0);
                                event.target.playVideo();
                                this.$iframe = $("#player");
                                this.rescale();
                            }
                        },
                    });

                    $(window).on('load resize', () => {
                        this.rescale();
                    });

                }, 2000);
            },

            open: function(url) {
                VuedalsBus.$emit('new', {
                    name: 'youtube',
                    component: YoutubePopin,
                    props: {
                        url: url
                    }
                });
                return false;
            },

            rescale: function() {
                let w = $(".node-homepage__hero").width(),
                    h = $(".node-homepage__hero").height();
                if ( w/h > 16/9 ) {
                    this.player.setSize(w + 200, (w + 200) / 16*9);
                } else {
                    this.player.setSize((h + 300)/9*16, h + 300);
                }
                this.$iframe.css({'left': -(this.$iframe.outerWidth()-w)/2, 'top': -(this.$iframe.outerHeight()-h)/2 });
            },

            scroll() {
                $('html, body').animate({
                    scrollTop: $(".node-homepage__bottom").offset().top + 50
                });
            },

        },
        computed: {

            //videoYoutubeId: function() {
            //    let params = new URLSearchParams(URI(this.youtube).search());
            //    let v = params.get('v')
            //    return v;
            //}

        }
    }
</script>
